module.exports = __webpack_public_path__ + "static/media/G0142657_China-16.a1529a97.png";